import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2091924c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invoice-category-group" }
const _hoisted_2 = { class: "group-header" }
const _hoisted_3 = { class: "group-title" }
const _hoisted_4 = { class: "group-row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "group-label" }, "开票类目", -1))
const _hoisted_6 = {
  key: 0,
  class: "group-row"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "group-label" }, "开票数据", -1))
const _hoisted_8 = {
  key: 1,
  class: "group-data-summary"
}
const _hoisted_9 = { class: "summary-row" }
const _hoisted_10 = { style: {"color":"#e97132"} }
const _hoisted_11 = {
  key: 2,
  class: "group-empty"
}

import { ref, computed, watch, getCurrentInstance } from 'vue';
import {
  BaseButton,
  BaseSelect,
  BaseTable,
  useCreateModal,
  useTableColumn
} from 'xrk-components';
import { formatter } from '@/utils';
import { invoiceCategory } from '@V/invoice/src/data-source/apis';
import type { InvoiceType } from '@V/invoice/src/types';
import InvoiceSelectDataDialog from '../invoice-select-data-dialog/invoice-select-data-dialog.vue';
import type {
  CategoryGroups,
  IndividualNotInvoicedPageRespDTO
} from '@V/invoice/src/data-source/types';
import { SETTLEMENT_STATUS_OPTIONS } from '@V/invoice/src/constants/index';


export default /*#__PURE__*/_defineComponent({
  __name: 'individual-category-group-item',
  props: {
    groupIndex: {},
    formData: { default: () => ({}) },
    itemId: { default: null },
    settlementList: { default: () => [] },
    globalPreSelectedIds: { default: () => [] },
    disabled: { type: Boolean, default: false }
  },
  emits: ["remove", "update:data"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emits = __emit;

const localData = ref<{ itemId: number | null; itemName: string }>({
  itemId: null,
  itemName: ''
});

const selectedData = ref<IndividualNotInvoicedPageRespDTO[]>([]);

const canSelectData = computed(
  () =>
    props.formData?.theSellerId != null &&
    props.formData?.invoiceType != null &&
    // !!props.formData?.payPassagewayCode && // 后端要求去掉必选
    localData.value.itemId != null
);

const selectedTotalAmount = computed(() => {
  return selectedData.value.reduce((sum, item) => {
    return sum + (item.terminalSettlementAmount || 0);
  }, 0);
});

const summaryColumns = computed(() => [
  useTableColumn({
    label: '结算单号',
    prop: 'settlementNo',
    width: '160px'
  }),
  useTableColumn({
    label: '项目名称',
    prop: 'projectName',
    minWidth: '120px'
  }),
  useTableColumn({
    label: '工业名称',
    prop: 'industryName',
    width: '140px'
  }),
  useTableColumn({
    label: '个体户名称',
    prop: 'individualName',
    width: '130px'
  }),
  useTableColumn({
    label: '终端结算金额(元)',
    prop: 'terminalSettlementAmount',
    width: '160px',
    formatter: ({ cellValue }) => formatter.fen2yuan(cellValue)
  }),
  useTableColumn({
    label: '结算单确认时间',
    prop: 'settlementConfirmTime',
    minWidth: '150px',
    formatter: ({ cellValue }) => formatter.date(cellValue)
  }),
  useTableColumn({
    label: '结算单状态',
    prop: 'settlementStatus',
    width: '100px',
    formatter: ({ cellValue }) =>
      formatter.defaultFormat(
        cellValue,
        () =>
          SETTLEMENT_STATUS_OPTIONS.find(o => o.value === cellValue)?.label ||
          '-'
      )
  })
]);

const categoryRemote = () => {
  return invoiceCategory({
    stateType: 7,
    invoiceType: props.formData?.invoiceType as InvoiceType,
    theSellerId: props.formData?.theSellerId,
    _t: props.groupIndex
  });
};

const onCategoryChange = (_val: any, [option]: any[]) => {
  localData.value.itemName = option?.itemName || '';
  emitUpdate();
};

const onOpenSelectData = () => {
  useCreateModal(
    InvoiceSelectDataDialog,
    {
      type: 1,
      globalPreSelectedIds: props.globalPreSelectedIds,
      currentPreSelectedIds: selectedData.value.map(
        (item: any) => item.settlementUserTaskId
      ),
      individualId: props.formData?.individualId,
      onConfirm(rows: any[]) {
        selectedData.value = rows;
        emitUpdate();
      }
    },
    getCurrentInstance()
  );
};

const emitUpdate = () => {
  emits('update:data', {
    itemId: localData.value.itemId,
    itemName: localData.value.itemName,
    settlementList: selectedData.value
  });
};

watch(
  () => [props.formData?.invoiceType, props.formData?.theSellerId],
  () => {
    localData.value.itemId = null;
    localData.value.itemName = '';
    selectedData.value = [];
  }
);

watch(
  () => [props.itemId, props.settlementList],
  () => {
    localData.value.itemId = props.itemId ?? null;
    selectedData.value = props.settlementList ? [...props.settlementList] : [];
  },
  { immediate: true }
);

__expose({
  getData: () => ({
    itemId: localData.value.itemId,
    itemName: localData.value.itemName,
    settlementList: selectedData.value
  })
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, "开票类目 " + _toDisplayString(_ctx.groupIndex + 1), 1),
      (_ctx.groupIndex > 0 && !_ctx.disabled)
        ? (_openBlock(), _createBlock(_unref(BaseButton), {
            key: 0,
            type: "text",
            style: {"color":"#fa4d56"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('remove', _ctx.groupIndex)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 删除 ")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_unref(BaseSelect), {
        class: "group-select",
        placeholder: "请选择",
        "label-key": "itemName",
        "value-key": "id",
        init: true,
        remoteMethod: categoryRemote,
        disabled: _ctx.disabled || !_ctx.formData.invoiceType,
        modelValue: localData.value.itemId,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localData.value.itemId) = $event)),
        onChange: onCategoryChange
      }, null, 8, ["disabled", "modelValue"])
    ]),
    (!_ctx.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_unref(BaseButton), {
            type: "text",
            onClick: onOpenSelectData,
            disabled: !canSelectData.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 选择开票数据 ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true),
    (selectedData.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", null, [
              _createTextVNode(" 已选 "),
              _createElementVNode("b", null, _toDisplayString(selectedData.value.length), 1),
              _createTextVNode(" 条 ")
            ]),
            _createElementVNode("span", _hoisted_10, " 申请开票金额：¥" + _toDisplayString(_unref(formatter).fen2yuan(selectedTotalAmount.value)), 1)
          ]),
          _createVNode(_unref(BaseTable), {
            class: "group-table",
            data: selectedData.value,
            columns: summaryColumns.value,
            pagination: false,
            size: "small"
          }, null, 8, ["data", "columns"])
        ]))
      : (!_ctx.disabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, "暂未选择开票数据"))
        : _createCommentVNode("", true)
  ]))
}
}

})